import { IConfig } from "./configTypes";

export const config: IConfig = {
	mode: (import.meta as any).env.MODE || "production",
	frontendThemeName: (import.meta as any).env.VITE_FRONTEND_THEME_NAME,
	sidebarHeaderHref: (import.meta as any).env.VITE_SIDEBAR_HEADER_HREF || undefined,
};
